'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../../index-0e40e0c2.js');

var refType = index.PropTypes.oneOfType([index.PropTypes.func, index.PropTypes.object]);

exports.default = refType;
//# sourceMappingURL=refType.js.map
